module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tweetPictures"
    }
  }, [_c('div', {
    staticClass: "faultClass container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "clearfix",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart",
      class: {
        'warning-border': item.isDefault == 1
      }
    }, [_vm._v("\n        " + _vm._s(item.modelName) + "\n        "), _c('div', {
      staticClass: "item-desc"
    }, [_vm._v(_vm._s(item.modelList))]), _vm._v(" "), _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editInfo(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          return _vm.deleteModel(item)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": _vm.addInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2)]), _vm._v(" "), _c('model-adapter-edit', {
    ref: "infoRef",
    on: {
      "refresh": _vm.loadData
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n      小程序型号适配\n      "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("可前往: https://hubweb.cn/ 查询")])])
}]}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-627e8687","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/modelAdapter/index.vue
// module id = 1687
// module chunks = 0